import { ClusterDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ClusterActions from './cluster.actions';

export const CLUSTER_FEATURE_KEY = 'cluster';

export interface ClusterState extends EntityState<ClusterDto> {
  selectedClusterId?: string | number; // which Cluster record has been selected
  loaded: boolean; // has the Cluster list been loaded
  error?: string | null; // last none error (if any)
}

export interface ClusterPartialState {
  readonly [CLUSTER_FEATURE_KEY]: ClusterState;
}

export const clusterAdapter: EntityAdapter<ClusterDto> = createEntityAdapter<
  ClusterDto
>({
  selectId: (cluster) => cluster.id,
  sortComparer: false,
});

export const initialState: ClusterState = clusterAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedClusterId: null,
});

const clusterReducer = createReducer(
  initialState,
  on(ClusterActions.loadCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ClusterActions.loadClusterSuccess, (state, { cluster }) =>
    clusterAdapter.addAll(cluster, { ...state, loaded: false })
  ),
  on(ClusterActions.loadClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ClusterActions.addCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ClusterActions.addClusterSuccess, (state, { newCluster }) =>
    clusterAdapter.addMany(newCluster, { ...state, loaded: false })
  ),
  on(ClusterActions.addClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ClusterActions.updateCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ClusterActions.updateClusterSuccess, (state, { updateCluster }) =>
    clusterAdapter.upsertMany(updateCluster, { ...state, loaded: false })
  ),
  on(ClusterActions.updateClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ClusterActions.removeCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ClusterActions.removeClusterSuccess, (state, { ids }) =>
    clusterAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(ClusterActions.removeClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: ClusterState | undefined, action: Action) {
  return clusterReducer(state, action);
}
